import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { MediaItem } from '../media-gallery/media-gallery.component';

@Component({
  selector: 'app-media-thumbnail-drawer',
  templateUrl: './media-thumbnail-drawer.component.html',
  styleUrls: ['./media-thumbnail-drawer.component.scss'],
  imports: [CommonModule, ButtonModule, TooltipModule]
})
export class MediaThumbnailDrawerComponent {
  @Input() media: MediaItem[] = [];
  @Input() isVisible: boolean = false;
  @Input() isPinned: boolean = false;
  @Output() closeDrawer = new EventEmitter<void>();
  @Output() openFullGallery = new EventEmitter<void>();
  @Output() capturePhoto = new EventEmitter<void>();
  @Output() pinToggled = new EventEmitter<boolean>();
  @Output() mouseLeave = new EventEmitter<void>();

  onClose() {
    this.closeDrawer.emit();
  }

  onOpenFullGallery() {
    this.openFullGallery.emit();
  }

  onCapturePhoto() {
    this.capturePhoto.emit();
  }

  onTogglePin() {
    this.pinToggled.emit(!this.isPinned);
  }

  onMouseLeave() {
    this.mouseLeave.emit();
  }

  getMediaUrl(item: MediaItem): string {
    // Use cached URLs first for better performance, then fall back to regular URLs
    return item.cachedThumbnailUrl || item.thumbnailUrl || item.cachedUrl || item.url || '';
  }

  trackByMediaId(index: number, item: MediaItem): string {
    return item.id || index.toString();
  }

  formatTimestamp(timestamp: Date | string | undefined): string {
    if (!timestamp) return '';
    const date = typeof timestamp === 'string' ? new Date(timestamp) : timestamp;
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  }
}

